import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19a149d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-page" }
const _hoisted_2 = { class: "home-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "brand-mark" }, "F", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Fin", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("nav", {
  class: "home-nav",
  "aria-label": "Navegação principal"
}, [
  /*#__PURE__*/_createElementVNode("a", { href: "#como-funciona" }, "Como funciona"),
  /*#__PURE__*/_createElementVNode("a", { href: "#recursos" }, "Recursos"),
  /*#__PURE__*/_createElementVNode("a", { href: "#planos" }, "Planos")
], -1))
const _hoisted_6 = { class: "header-actions" }
const _hoisted_7 = { class: "hero" }
const _hoisted_8 = { class: "hero-content" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "eyebrow" }, "Finanças por WhatsApp", -1))
const _hoisted_10 = { "aria-label": "O Fin registra gastos, categoriza tudo, resume o mês, lembra vencimentos e organiza entradas para você." }
const _hoisted_11 = { class: "hero-title__line" }
const _hoisted_12 = {
  class: "hero-title__dynamic-slot",
  "aria-hidden": "true"
}
const _hoisted_13 = { class: "hero-title__measure" }
const _hoisted_14 = { class: "hero-title__animated" }
const _hoisted_15 = { class: "hero-title__dynamic" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hero-title__caret" }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Transforme mensagens simples em lançamentos, categorias, compromissos e indicadores claros para acompanhar o mês sem planilhas confusas. ", -1))
const _hoisted_18 = { class: "hero-actions" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ph ph-arrow-right" }, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "trust-strip",
  "aria-label": "Destaques do produto"
}, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "ph ph-whatsapp-logo" }),
    /*#__PURE__*/_createTextVNode(" WhatsApp")
  ]),
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "ph ph-sparkle" }),
    /*#__PURE__*/_createTextVNode(" IA")
  ]),
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "ph ph-chart-line-up" }),
    /*#__PURE__*/_createTextVNode(" Tempo real")
  ])
], -1))
const _hoisted_21 = /*#__PURE__*/_createStaticVNode("<aside class=\"app-preview\" aria-label=\"Prévia do aplicativo financeiro\" data-v-19a149d8><div class=\"phone-shell\" data-v-19a149d8><div class=\"phone-top\" data-v-19a149d8><span data-v-19a149d8>Hoje</span><strong data-v-19a149d8>Atualizado</strong></div><div class=\"message-bubble\" data-v-19a149d8><span class=\"message-bubble__icon\" data-v-19a149d8><i class=\"ph ph-whatsapp-logo\" data-v-19a149d8></i></span><p data-v-19a149d8>Anota 48,90 do almoço de hoje</p></div><div class=\"result-card\" data-v-19a149d8><div data-v-19a149d8><span data-v-19a149d8>Lançamento criado</span><strong data-v-19a149d8>R$ 48,90</strong></div><i class=\"ph ph-check-circle\" data-v-19a149d8></i></div><div class=\"preview-actions\" data-v-19a149d8><span data-v-19a149d8><i class=\"ph ph-plus\" data-v-19a149d8></i> Novo gasto</span><span data-v-19a149d8><i class=\"ph ph-receipt\" data-v-19a149d8></i> Lançamentos</span></div><div class=\"mini-dashboard\" data-v-19a149d8><div data-v-19a149d8><small data-v-19a149d8>Gastos em junho</small><strong data-v-19a149d8>R$ 2.847,90</strong></div><div class=\"mini-row\" data-v-19a149d8><span data-v-19a149d8>Mercado</span><b data-v-19a149d8>42%</b></div><div class=\"progress-track\" data-v-19a149d8><span style=\"width:74%;\" data-v-19a149d8></span></div></div></div></aside>", 1)
const _hoisted_22 = /*#__PURE__*/_createStaticVNode("<section id=\"como-funciona\" class=\"section flow-section\" data-v-19a149d8><div class=\"section-heading\" data-v-19a149d8><span class=\"eyebrow\" data-v-19a149d8>Como funciona</span><h2 data-v-19a149d8>Da frase solta ao financeiro organizado</h2><p data-v-19a149d8>O caminho foi pensado para parecer natural para quem usa e confiável para quem acompanha.</p></div><div class=\"steps\" data-v-19a149d8><article data-v-19a149d8><span class=\"step-icon\" data-v-19a149d8><i class=\"ph ph-chat-circle-text\" data-v-19a149d8></i></span><small data-v-19a149d8>Passo 1</small><h3 data-v-19a149d8>Envie como você fala</h3><p data-v-19a149d8>O cliente manda uma mensagem simples pelo WhatsApp, sem precisar abrir planilha ou preencher formulário.</p></article><article data-v-19a149d8><span class=\"step-icon\" data-v-19a149d8><i class=\"ph ph-sparkle\" data-v-19a149d8></i></span><small data-v-19a149d8>Passo 2</small><h3 data-v-19a149d8>A IA organiza</h3><p data-v-19a149d8>Valor, descrição, categoria e data são interpretados e salvos como lançamento financeiro.</p></article><article data-v-19a149d8><span class=\"step-icon\" data-v-19a149d8><i class=\"ph ph-chart-pie-slice\" data-v-19a149d8></i></span><small data-v-19a149d8>Passo 3</small><h3 data-v-19a149d8>O app resume tudo</h3><p data-v-19a149d8>Dashboard, gastos, fixos e pagamentos ficam prontos para leitura rápida, com cara de aplicativo.</p></article></div></section><section id=\"recursos\" class=\"section product-section\" data-v-19a149d8><div class=\"product-card product-card--featured\" data-v-19a149d8><span class=\"eyebrow\" data-v-19a149d8>Experiência de app</span><h2 data-v-19a149d8>O essencial aparece primeiro. O detalhe fica a um toque.</h2><p data-v-19a149d8> A home apresenta o mesmo jeito de usar que o cliente encontra depois do login: ações óbvias, cartões limpos e leitura rápida no celular. </p></div><div class=\"feature-grid\" data-v-19a149d8><article data-v-19a149d8><span data-v-19a149d8><i class=\"ph ph-gauge\" data-v-19a149d8></i></span><h3 data-v-19a149d8>Dashboard direto</h3><p data-v-19a149d8>Total do mês, comparação e atalhos para agir sem perder tempo.</p></article><article data-v-19a149d8><span data-v-19a149d8><i class=\"ph ph-arrows-down-up\" data-v-19a149d8></i></span><h3 data-v-19a149d8>Gastos e entradas</h3><p data-v-19a149d8>Histórico com filtros, detalhes e a mensagem original enviada para a IA.</p></article><article data-v-19a149d8><span data-v-19a149d8><i class=\"ph ph-calendar-check\" data-v-19a149d8></i></span><h3 data-v-19a149d8>Compromissos fixos</h3><p data-v-19a149d8>Agenda de vencimentos com visão de todos, vencidos e próximos pagamentos.</p></article><article data-v-19a149d8><span data-v-19a149d8><i class=\"ph ph-credit-card\" data-v-19a149d8></i></span><h3 data-v-19a149d8>Planos e conta</h3><p data-v-19a149d8>Pagamentos, configurações e equipe com visual simples para o cliente final.</p></article></div></section>", 2)
const _hoisted_24 = {
  id: "planos",
  class: "section plans-section"
}
const _hoisted_25 = { class: "section-heading section-heading--inline" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "eyebrow" }, "Planos"),
  /*#__PURE__*/_createElementVNode("h2", null, "Escolha o melhor começo para sua rotina")
], -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ph ph-arrow-right" }, null, -1))
const _hoisted_28 = {
  key: 0,
  class: "plans-grid",
  "aria-label": "Carregando planos"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "skeleton skeleton-title" }, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "skeleton skeleton-text" }, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "skeleton skeleton-price" }, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "skeleton skeleton-button" }, null, -1))
const _hoisted_33 = [
  _hoisted_29,
  _hoisted_30,
  _hoisted_31,
  _hoisted_32
]
const _hoisted_34 = {
  key: 1,
  class: "plans-feedback plans-feedback--error"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph ph-warning-circle" })
], -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h3", null, "Não foi possível carregar os planos"),
  /*#__PURE__*/_createElementVNode("p", null, "Tente novamente ou continue criando sua conta para escolher o plano depois.")
], -1))
const _hoisted_37 = {
  key: 2,
  class: "plans-feedback"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph ph-leaf" })
], -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h3", null, "Planos em atualização"),
  /*#__PURE__*/_createElementVNode("p", null, "Você ainda pode criar sua conta e concluir a escolha do plano na sequência.")
], -1))
const _hoisted_40 = {
  key: 3,
  class: "plans-grid"
}
const _hoisted_41 = { class: "plan-card__top" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "plan-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph ph-rocket-launch" })
], -1))
const _hoisted_43 = { key: 0 }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ph ph-check-circle" }, null, -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ph ph-arrow-right" }, null, -1))
const _hoisted_46 = { class: "home-footer" }
const _hoisted_47 = { class: "footer-grid" }
const _hoisted_48 = { class: "footer-brand" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "brand-mark" }, "F", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Fin", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Controle financeiro por WhatsApp, lançamentos organizados e métricas prontas para acompanhar o mês. ", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-column" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Produto"),
  /*#__PURE__*/_createElementVNode("a", { href: "#como-funciona" }, "Como funciona"),
  /*#__PURE__*/_createElementVNode("a", { href: "#recursos" }, "Recursos"),
  /*#__PURE__*/_createElementVNode("a", { href: "#planos" }, "Planos")
], -1))
const _hoisted_53 = { class: "footer-column" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Conta", -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-column" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Contato"),
  /*#__PURE__*/_createElementVNode("a", { href: "mailto:contato@sanvault.com.br" }, "contato@sanvault.com.br"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://wa.me/5511915100084",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "(11) 9 1510-0084")
], -1))
const _hoisted_56 = { class: "footer-bottom" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "API financeira integrada ao WhatsApp.", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "brand",
        "aria-label": "Ir para a página inicial"
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _hoisted_4
        ]),
        _: 1
      }),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_router_link, {
          to: "/login",
          class: "header-link"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Entrar")
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: _ctx.registerRoute,
          class: "header-cta"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Começar")
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ]),
    _createElementVNode("section", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("h1", _hoisted_10, [
          _createElementVNode("span", _hoisted_11, [
            _createTextVNode(" O Fin "),
            _createElementVNode("span", _hoisted_12, [
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.heroMeasurePhrase), 1),
              _createElementVNode("span", _hoisted_14, [
                _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.typedHeroPhrase), 1),
                _hoisted_16
              ])
            ])
          ])
        ]),
        _hoisted_17,
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_router_link, {
            to: _ctx.registerRoute,
            class: "primary-button"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Começar agora "),
              _hoisted_19
            ]),
            _: 1
          }, 8, ["to"]),
          _createVNode(_component_router_link, {
            to: "/login",
            class: "secondary-button"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Já tenho conta")
            ]),
            _: 1
          })
        ]),
        _hoisted_20
      ]),
      _hoisted_21
    ]),
    _hoisted_22,
    _createElementVNode("section", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, [
        _hoisted_26,
        _createVNode(_component_router_link, {
          to: _ctx.registerRoute,
          class: "small-action"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Criar conta "),
            _hoisted_27
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      (_ctx.isLoadingPlans)
        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (index) => {
              return _createElementVNode("article", {
                key: index,
                class: "plan-card plan-card--loading"
              }, _hoisted_33)
            }), 64))
          ]))
        : (_ctx.plansError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
              _hoisted_35,
              _hoisted_36,
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.loadPlans && _ctx.loadPlans(...args)))
              }, "Tentar novamente")
            ]))
          : (!_ctx.plans.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                _hoisted_38,
                _hoisted_39,
                _createVNode(_component_router_link, { to: "/register" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Criar conta")
                  ]),
                  _: 1
                })
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_40, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.plans, (plan) => {
                  return (_openBlock(), _createElementBlock("article", {
                    key: plan.id,
                    class: "plan-card"
                  }, [
                    _createElementVNode("div", _hoisted_41, [
                      _hoisted_42,
                      _createElementVNode("h3", null, _toDisplayString(plan.name), 1)
                    ]),
                    _createElementVNode("p", null, _toDisplayString(plan.description || "Plano para acompanhar sua rotina financeira pelo aplicativo."), 1),
                    _createElementVNode("strong", null, _toDisplayString(_ctx.formatPlanPrice(plan)), 1),
                    (_ctx.planFeatures(plan).length)
                      ? (_openBlock(), _createElementBlock("ul", _hoisted_43, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.planFeatures(plan), (feature) => {
                            return (_openBlock(), _createElementBlock("li", { key: feature }, [
                              _hoisted_44,
                              _createTextVNode(" " + _toDisplayString(feature), 1)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_router_link, {
                      to: _ctx.planRegisterRoute(plan),
                      class: "plan-button"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Contratar "),
                        _hoisted_45
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]))
                }), 128))
              ]))
    ]),
    _createElementVNode("footer", _hoisted_46, [
      _createElementVNode("div", _hoisted_47, [
        _createElementVNode("div", _hoisted_48, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "brand"
          }, {
            default: _withCtx(() => [
              _hoisted_49,
              _hoisted_50
            ]),
            _: 1
          }),
          _hoisted_51
        ]),
        _hoisted_52,
        _createElementVNode("div", _hoisted_53, [
          _hoisted_54,
          _createVNode(_component_router_link, { to: "/login" }, {
            default: _withCtx(() => [
              _createTextVNode("Entrar")
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/register" }, {
            default: _withCtx(() => [
              _createTextVNode("Criar conta")
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/forgot-password" }, {
            default: _withCtx(() => [
              _createTextVNode("Esqueci minha senha")
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/terms" }, {
            default: _withCtx(() => [
              _createTextVNode("Termos de uso")
            ]),
            _: 1
          })
        ]),
        _hoisted_55
      ]),
      _createElementVNode("div", _hoisted_56, [
        _createElementVNode("span", null, "© " + _toDisplayString(_ctx.currentYear) + " Fin. Todos os direitos reservados.", 1),
        _hoisted_57
      ])
    ])
  ]))
}